import HelpIcon from '@jetbrains/icons/help.svg'
import React from 'react'

import {resolveHelpURL} from '../../../utils/url'
import Link from '../../common/Link/Link'
import Loader from '../../common/Loader/Loader'
import SvgIcon from '../../common/SvgIcon/SvgIcon'

import MatrixParamBuildProvider from './contexts/MatrixParamBuildContext'
import MatrixParamBuildErrorProvider from './contexts/MatrixParamBuildErrorContext'
import useMatrixParamBuild from './hooks/useMatrixParamBuild'
import type {MatrixParamBuildProps} from './MatrixParamBuild.types'
import MatrixParamBuildParameters from './MatrixParamBuildParameters/MatrixParamBuildParameters'

import styles from './MatrixParamBuild.css'

function MatrixParamBuild({
  buildTypeId,
  projectId,
  featureId,
  featureType,
  readOnly,
}: MatrixParamBuildProps) {
  const {
    isLoading,
    isReadOnlyMode,
    errorMessages,
    data,
    projectsDefaultValueSets,
    matrixParamBuildSubmitHandler,
    matrixParamBuildViweAsCodeSubmitHandler,
  } = useMatrixParamBuild(buildTypeId, projectId, featureId, featureType, readOnly)

  if (isLoading) {
    return <Loader />
  }

  return (
    <MatrixParamBuildErrorProvider isReadOnlyMode={isReadOnlyMode} externalErrors={errorMessages}>
      <div className={styles.description}>
        {'Iterates over parameter values and creates a separate build for every combination'}
        <Link target={'_blank'} rel={'noreferrer'} href={resolveHelpURL('matrix-build.html')}>
          {() => <SvgIcon className={styles.helpIcon} icon={HelpIcon} />}
        </Link>
      </div>
      <MatrixParamBuildProvider
        buildTypeId={buildTypeId}
        onSubmit={matrixParamBuildSubmitHandler}
        onViweAsCodeSubmit={matrixParamBuildViweAsCodeSubmitHandler}
        options={projectsDefaultValueSets}
        data={data}
      >
        <MatrixParamBuildParameters isReadOnlyMode={isReadOnlyMode} />
      </MatrixParamBuildProvider>
    </MatrixParamBuildErrorProvider>
  )
}

export default MatrixParamBuild
